<script setup lang="ts">
import { PageUrl } from '~/types'
import Page from '~/components/Layout/Page.vue'
import Brands from '~/components/Homepage/Brands.vue'
import Categories from '~/components/Homepage/Categories.vue'
import NewRates from '~/components/Homepage/NewRates.vue'

const { isMobile } = useBreakpoint()
const { page } = storeToRefs(usePageStore())
const { loadPage, setCurrentUrl } = usePageStore()
const { loadBrandList } = useBrandStore()
const { resetFilters } = useFilterStore()

definePageMeta({
  layout: 'homepage',
})

// await diretto su loadPage, non avvolto in useAsyncData (vedi [...all].vue per il dettaglio)
await loadPage(PageUrl.HOMEPAGE)
// brand-list resta su useAsyncData: a differenza di loadPage, non scrive un
// dato specifico-per-pagina (stessa lista di brand ovunque), quindi la sua
// cache per chiave non causa lo stesso disallineamento.
await useAsyncData('brand-list', async () => await loadBrandList())

onBeforeMount(() => {
  setCurrentUrl(PageUrl.HOMEPAGE)
})

onMounted(() => {
  resetFilters()
})
</script>

<template>
  <Page v-if="page" :page="page" type="homepage" title="Confronta Offerte Luce, Gas, Telefonia e Internet" :hero="{ paddingBottom: isMobile ? 8 : 4, fitHeight: false }">
    <template #hero-content>
      <Categories />
    </template>
    <Brands />
    <NewRates />
  </Page>
</template>